import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	upgradeToStandardCtaLabel: {
		id: 'navigation-apps-sidebar-edition-awareness.free-pill.edition-awareness-cta-button.upgrade-to-standard-cta-label',
		defaultMessage: 'Upgrade',
		description: 'Label shown to users when they are on a free plan of Jira',
	},
});
